import { render, staticRenderFns } from "./OrderCotization.vue?vue&type=template&id=7b4e5b88&"
import script from "./OrderCotization.vue?vue&type=script&lang=js&"
export * from "./OrderCotization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports